import React, { createContext, useContext, useState } from 'react';

/** Fixed duration the tenant-change overlay is shown during a switch. */
export const TENANT_SWITCH_MIN_OVERLAY_MS = 1200;

interface TenantSwitchingContextType {
  isSwitching: boolean;
  setIsSwitching: (switching: boolean) => void;
  targetTenantName: string | null;
  setTargetTenantName: (name: string | null) => void;
  /** Set when the user initiates a switch; cleared once URL and session align. */
  switchTargetTenantId: string | null;
  setSwitchTargetTenantId: (tenantId: string | null) => void;
}

const TenantChangeContext = createContext<TenantSwitchingContextType>({
  isSwitching: false,
  setIsSwitching: () => {},
  targetTenantName: null,
  setTargetTenantName: () => {},
  switchTargetTenantId: null,
  setSwitchTargetTenantId: () => {},
});

export const useTenantChange = () => {
  return useContext(TenantChangeContext);
};

export const TenantChangeProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isSwitching, setIsSwitching] = useState(false);
  const [targetTenantName, setTargetTenantName] = useState<string | null>(null);
  const [switchTargetTenantId, setSwitchTargetTenantId] = useState<
    string | null
  >(null);

  return (
    <TenantChangeContext.Provider
      value={{
        isSwitching,
        setIsSwitching,
        targetTenantName,
        setTargetTenantName,
        switchTargetTenantId,
        setSwitchTargetTenantId,
      }}
    >
      {children}
    </TenantChangeContext.Provider>
  );
};
